import createSagaMiddleware from 'redux-saga';

import { pushRollbarError } from '../utils/rollbarInit';

export const sagaMiddleware = createSagaMiddleware({
    onError: pushRollbarError,
});

const middlewares = [sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger');
    middlewares.push(createLogger({ collapsed: true }));
}

export default middlewares;
